import React, { useEffect, useState } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";
import { getTypeColor, getTypeTextColor } from "../../utilz/function";

interface CustomerData {
  _id: string;
  contactName: string;
  businessName: string;
  email: string;
  contactNumber: string;
  accountType: string;
  totalOrders: number;
  totalSpent: number;
  createdAt: string;
  isActive: boolean;
  approvalStatus: string;
}

interface UserTableProps {
  data: CustomerData[];
  selectedStatus?: string;
  handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const CustomerTable: React.FC<UserTableProps> = ({ data, selectedStatus }) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState<CustomerData[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const columns = [
    { header: "Name", accessor: "contactName" },
    { header: "Contact", accessor: "contact" },
    { header: "Type", accessor: "type" },
    { header: "Total Orders", accessor: "totalOrders" },
    { header: "Total Spent", accessor: "totalSpent" },
    { header: "Status", accessor: "approvalStatus" },
    { header: "Actions", accessor: "_id" },
  ];

  const handleUserClick = (_id: string) => {
    navigate(`/dashboard/customers/${_id}`);
  };

  useEffect(() => {
    const filtered = data?.filter((customer) => {
      const statusMatch =
        !selectedStatus || customer?.accountType === selectedStatus;

      const searchMatch =
        !searchQuery ||
        customer?.contactName
          ?.toLowerCase()
          .includes(searchQuery?.toLowerCase()) ||
        customer.email?.toLowerCase().includes(searchQuery?.toLowerCase());
      const customerMatch =
        !selectedType || customer?.accountType === selectedType;

      return statusMatch && searchMatch && customerMatch;
    });
    setFilteredData(filtered);
  }, [data, selectedStatus, searchQuery, selectedType]);

  const combinedData = filteredData?.map((customer) => ({
    ...customer,
    contact: (
      <div>
        <div>{customer.email}</div>
        <div>{customer?.contactNumber || "N/A"}</div>
      </div>
    ),
    status: (
      <div className="capitalize">
        <div className="capitalize">{customer.approvalStatus}</div>
        
      </div>
    ),

    contactName: (
    
        <div className="capitalize">
          {customer.accountType === "b2b"
            ? customer?.businessName
            : customer?.contactName}
        </div>
      
    ),

    type: (
      <div>
        <span
          className="font-normal rounded-full p-2"
          style={{
            backgroundColor: getTypeColor(customer?.accountType),
            color: getTypeTextColor(customer?.accountType),
          }}
        >
          {customer.accountType === "b2b" ? "B2B" : "B2C"}
        </span>
      </div>
    ),
  }));

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleCustomerFilterChange = (selectedValue: string) => {
    setSelectedType(selectedValue);
  };

  return (
    <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
      <div className="md:flex justify-between px-5">
        <p className="text-[20px] font-bold">Customer</p>
        <div className="md:flex gap-2 items-center md:mt-0 mt-2">
          <Input
            name="search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full"
            placeholder="Search"
            icon="searchIcon"
          />

          <FIlterSelect
            name="accounType"
            options={[
              { value: "b2b", label: "Business" },
              { value: "b2c", label: "Customer" },
            ]}
            className="mt-2 md:-mt-2 w-full md:w-[50%]"
            icon="filterIcon"
            onChange={handleCustomerFilterChange}
            value={selectedType}
          />
        </div>
      </div>

      {combinedData?.length > 0 ? (
        <Table
          columns={columns}
          data={combinedData}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="opacity-80 mt-10 font-bold  text-center mx-auto">
          No customers found
        </div>
      )}
    </div>
  );
};

export default CustomerTable;
